module.exports = __webpack_public_path__ + "img/general.819dfed7.png";